import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import { TablePagination, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment } from "@mui/material";
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import EventIcon from '@mui/icons-material/Event';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow} from '../tabs_style';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


export default function PeriodosLeyAnterior() {
  const [tabIndex, setTabIndex] = React.useState(7);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const rows = [
    {
      inicio: "", final: "", no: "", sueldos: "", seis: "", cero: "", totales: "", periodos: ""
    },
    {
      inicio: "", final: "", no: "", sueldos: "", seis: "", cero: "", totales: "", periodos: ""
    },
    {
      inicio: "", final: "", no: "", sueldos: "", seis: "", cero: "", totales: "", periodos: ""
    },
    {
      inicio: "", final: "", no: "", sueldos: "", seis: "", cero: "", totales: "", periodos: ""
    },
    {
      inicio: "", final: "", no: "", sueldos: "", seis: "", cero: "", totales: "", periodos: ""
    },

  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h2 style={{ textAlign: 'center' }}>Períodos</h2>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Tasas Por Año" />
                <AntTab label="Monto Del Beneficio" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Rebajas" />
                <AntTab label="Períodos" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Con Reingreso" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
            {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
            {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
            {tabIndex === 4 && navigate('Separaciones/LeyAnterior')}
            {tabIndex === 5 && navigate('/Separaciones/CalculosLeyAnterior')}
            {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
            {tabIndex === 7}
            {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
            {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}

          </Box>
        </Container>
      </Grid>

      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ textAlign: 'center' }}>Hoja de Investigación de Aportaciones para Retiro del Sistema <br />Sección de Registro y Afiliación</h2>
      </Container>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="participante"
                    label="Participante"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="fecha"
                    label="Fecha"
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <EventIcon />
                        </InputAdornment>
                      ),
                      readOnly: true
                    }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="cotizante"
                    label="Cotizante"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="dependencia"
                    label="Dependencia"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="noexpediente"
                    label="No. Expediente"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="observaciones"
                    label="Observaciones"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="aportacionesantes"
                    label="Aportaciones Antes del RO"
                    variant="outlined"
                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="c1"
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" style={{ marginTop: 5 }}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="aportacionesdoce"
                    label="Aportaciones del RO al 12/05/2015"
                    variant="outlined"
                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="c2"
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" style={{ marginTop: 5 }}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="aportacionestrece"
                    label="Aportaciones del 13/05/2014 en Adelante"
                    variant="outlined"
                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="c3"
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" style={{ marginTop: 5 }}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="total"
                    label="Total de Aportaciones"
                    variant="outlined"
                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="c4"
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <div>
        <TableContainer component={Paper} style={{ marginTop: 30 }}>
          {/* Tabla 2 */}
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>Período Inicio</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>Período Final</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>No.</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>Sueldos</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>6.5%</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>0.07</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>Totales</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>Períodos</strong></StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows
              ).map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.inicio}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.final}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.no}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.sueldos}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.seis}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.cero}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.totales}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{row.periodos}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}
